export class NewsLetterSubscription {
    constructor() {
        this.domain =
            'https://jqkhka3wk8.execute-api.eu-west-1.amazonaws.com/production/global-email-capture';
    }

    static properties() {
        return {
            email: null,
            current_url: null,
            us_state: null,
            debug: null,
            product_type_feature: null,
            hidden_input: null,
            website_ref: 'gambling_com',
            country: 'US',
        };
    }

    subscribe(payload) {
        if (typeof payload !== 'object' || payload.hidden_input != '') payload = {};

        payload = $.extend(true, NewsLetterSubscription.properties(), payload);

        let self = this;

        return new Promise(function (resolve, reject) {
            let ajax = $.ajax({
                url: self.domain,
                contentType: 'application/json; charset=utf-8',
                type: 'POST',
                dataType: 'JSON',
                data: JSON.stringify(payload),
                success: function (response) {
                    resolve(response);
                },
                error: function (err) {
                    reject(err);
                },
            });
        });
    }
}
